import React from 'react'

/* ---- Source SVG icons ---- */
const SourceIcons = {
  voicemail: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="5.5" cy="11.5" r="4.5"/><circle cx="18.5" cy="11.5" r="4.5"/><line x1="5.5" y1="16" x2="18.5" y2="16"/>
    </svg>
  ),
  sms: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  phone_call: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  email: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  field_observation: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  walk_in: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  aspire_work_order: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  ),
  customer_portal: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
    </svg>
  ),
}

/* ---- Tab icons ---- */
const TabIcons = {
  queue: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
    </svg>
  ),
  assigned: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/>
    </svg>
  ),
  completed: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
}

/* ---- Source label map ---- */
const SOURCE_LABELS = {
  voicemail: 'Voicemail',
  sms: 'SMS',
  phone_call: 'Phone Call',
  email: 'Email',
  field_observation: 'Field Observation',
  walk_in: 'Walk-in',
  aspire_work_order: 'Aspire WO',
  customer_portal: 'Customer Portal',
}

/* ---- Time ago helper ---- */
export function timeAgo(dateStr) {
  if (!dateStr) return ''
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'now'
  if (mins < 60) return `${mins}m`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d`
  const weeks = Math.floor(days / 7)
  return `${weeks}w`
}

/* ---- Due date label helper ---- */
function dueLabel(dateStr) {
  if (!dateStr) return null
  const due = new Date(dateStr)
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate())
  const diffDays = Math.round((dueDay - today) / 86400000)
  if (diffDays < 0) return 'Overdue'
  if (diffDays === 0) return 'Due today'
  if (diffDays === 1) return 'Due tomorrow'
  return `Due in ${diffDays}d`
}

const TABS = [
  { key: 'submitted', label: 'Queue', icon: 'queue' },
  { key: 'assigned', label: 'Assigned', icon: 'assigned' },
  { key: 'completed', label: 'Completed', icon: 'completed' },
]

export default function UnclaimedWorkList({
  items = [],
  stats = {},
  activeTab = 'submitted',
  filters = {},
  selectedId,
  onTabChange,
  onFilterChange,
  onSelect,
}) {
  const sortNewest = filters.sort === 'newest'

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      {/* Tab bar */}
      <div className="uw-tab-bar">
        {TABS.map(tab => {
          const count = tab.key === 'submitted' ? (stats.submitted || 0)
            : tab.key === 'assigned' ? (stats.assigned || 0)
            : (stats.completedToday || 0)
          const isActive = activeTab === tab.key
          const isUrgent = tab.key === 'submitted' && (stats.urgent || 0) > 0
          return (
            <button
              key={tab.key}
              className={`uw-tab${isActive ? ' active' : ''}`}
              onClick={() => onTabChange(tab.key)}
            >
              {TabIcons[tab.icon]}
              {tab.label}
              <span className={`uw-tab-count${isUrgent && isActive ? ' urgent' : ''}`}>
                {count}
              </span>
            </button>
          )
        })}
      </div>

      {/* Filter bar */}
      <div className="uw-filter-bar">
        <select
          className="uw-filter-select"
          value={filters.priority || ''}
          onChange={e => onFilterChange({ ...filters, priority: e.target.value })}
        >
          <option value="">Priority: All</option>
          <option value="urgent">Urgent</option>
          <option value="normal">Normal</option>
          <option value="low">Low</option>
        </select>
        <select
          className="uw-filter-select"
          value={filters.source || ''}
          onChange={e => onFilterChange({ ...filters, source: e.target.value })}
        >
          <option value="">Source: All</option>
          <option value="phone_call">Phone Call</option>
          <option value="voicemail">Voicemail</option>
          <option value="sms">SMS</option>
          <option value="email">Email</option>
          <option value="walk_in">Walk-in</option>
          <option value="field_observation">Field Observation</option>
        </select>
        <select
          className="uw-filter-select"
          value={filters.service_type || ''}
          onChange={e => onFilterChange({ ...filters, service_type: e.target.value })}
        >
          <option value="">Service: All</option>
          <option value="Irrigation">Irrigation</option>
          <option value="Herbicide">Herbicide</option>
          <option value="Landscape">Landscape</option>
          <option value="Enhancement">Enhancement</option>
          <option value="Drainage">Drainage</option>
          <option value="Install">Install</option>
        </select>
        <span className="uw-filter-spacer" />
        <button
          className="uw-sort-label"
          onClick={() => onFilterChange({ ...filters, sort: sortNewest ? 'oldest' : 'newest' })}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
          {sortNewest ? 'Newest first' : 'Oldest first'}
        </button>
      </div>

      {/* Item list */}
      <div className="uw-item-list">
        {items.length === 0 && (
          <div className="uw-empty-state" style={{ minHeight: 300 }}>
            <div className="uw-empty-glyph">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
              </svg>
            </div>
            <div className="uw-empty-title">No items</div>
            <div className="uw-empty-desc">
              {activeTab === 'submitted' ? 'The queue is empty. New items will appear here.' :
               activeTab === 'assigned' ? 'No items are currently assigned.' :
               'No completed items found.'}
            </div>
          </div>
        )}
        {items.map(item => {
          const isSelected = item._id === selectedId
          const sourceKey = item.source || 'phone_call'
          const Icon = SourceIcons[sourceKey] || SourceIcons.phone_call
          const serviceTypes = item.service_types || []
          const due = dueLabel(item.due_date)

          return (
            <div
              key={item._id}
              className={`uw-item-row${isSelected ? ' selected' : ''}`}
              onClick={() => onSelect(item._id)}
            >
              <div className={`uw-source-icon ${sourceKey}`}>
                {Icon}
              </div>
              <div className="uw-item-body">
                <div className="uw-item-title-row">
                  <span className="uw-item-title">
                    {item.title || item.body?.substring(0, 80) || 'Untitled'}
                  </span>
                  <span className="uw-item-age">{timeAgo(item.createdAt)}</span>
                </div>
                <div className="uw-item-meta">
                  <span>{item.contact_name || SOURCE_LABELS[sourceKey] || 'Unknown'}</span>
                  {serviceTypes.length > 0 && (
                    <>
                      <span className="dot" />
                      <span>{serviceTypes[0]}</span>
                    </>
                  )}
                </div>
                <div className="uw-item-tags">
                  <span className={`uw-pill uw-pill-${item.priority || 'normal'}`}>
                    {(item.priority || 'normal').charAt(0).toUpperCase() + (item.priority || 'normal').slice(1)}
                  </span>
                  {serviceTypes.length > 0 && (
                    <span className="uw-pill uw-pill-service">{serviceTypes[0]}</span>
                  )}
                  {due && (
                    <span className="uw-pill uw-pill-due">{due}</span>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
